import * as React from 'react'
import Flex from 'components/Flex'

const FlexColumn = React.forwardRef(function FlexColumn (props, ref) {
  return (
    <Flex column {...props} ref={ref} />
  )
})

export default FlexColumn
